import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import FAQ from "./Pages/FAQ";
// import Footer from './Pages/HomePage/Footer/Footer';
import HomePage from "./Pages/HomePage";
import ScrollToTop from "./ScrollToTop";
import EditProfile from "./Pages/Account/Profile/EditProfile/index.jsx";
import AuthPage from "./Pages/Auth";
import Terms from "./Pages/Terms";
import Privacy from "./Pages/Privacy/index.jsx";
import Profile from "./Pages/Account/Profile/index.jsx";
import JobSearch from "./Pages/Job/JobSearch/index.jsx";
import ViewJob from "./Pages/Job/ViewJob";
import ViewProfile from "./Pages/Account/Profile/ViewProfile";
// import SearchResults from "./Pages/Recruiter/SearchResults";
import RecruiterWrapper from "./Pages/Recruiter";
import { Box } from "@chakra-ui/core";
import CreateClients from "Pages/Recruiter/CreateClients";
import Scheduler from "Pages/Recruiter/Scheduler";
// import ATSWrapper from "Pages/Recruiter/ATS";
// import ATS from "Components/_ATS";
// import NavBar from './Components/NavBar/NavBar';

function Routes() {
  return (
    <Box>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ScrollToTop />
        {/* <Route path="/" render={() => <NavBar />} /> */}
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/faq" component={FAQ} />
          <Route exact path="/account/profile" component={Profile} />
          <Route exact path="/account/profile/edit" component={EditProfile} />
          <Route exact path="/account/profile/view" component={ViewProfile} />
          <Route exact path="/auth" component={AuthPage} />
          <Route exact path="/terms" component={Terms} />
          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/user/jobs/recommendation" component={JobSearch} />
          <Route exact path="/user/jobs/job/:jobId" component={ViewJob} />
          <Route exact path="/recruiter" component={RecruiterWrapper} />
          <Route exact path="/recruiter/jobs" component={RecruiterWrapper} />
          <Route
            exact
            path="/recruiter/jobs/:jobId"
            component={RecruiterWrapper}
          />
          <Route exact path="/recruiter/mail" component={RecruiterWrapper} />
          <Route exact path="/recruiter/search" component={RecruiterWrapper} />
          <Route
            exact
            path="/recruiter/approvals"
            component={RecruiterWrapper}
          />
          <Route
            exact
            path="/recruiter/settings"
            component={RecruiterWrapper}
          />
          <Route
            exact
            path="/recruiter/search/results"
            component={RecruiterWrapper}
          />
          <Route
            exact
            path="/recruiter/jobs/create"
            component={RecruiterWrapper}
          />
          <Route
            exact
            path="/recruiter/clients/create"
            component={CreateClients}
          />
          <Route exact path="/recruiter/scheduler" component={Scheduler} />
        </Switch>
        {/* <Route path="/" render={() => <Footer />} /> */}
      </BrowserRouter>
    </Box>
  );
}

export default Routes;
